export enum FeatureFlagsEnum {
    FF_Notifications = 'FF_Notifications',
    FF_DevAuditLogs = 'FF_DevAuditLogs',
    FF_DangerousMaintenanceOperations = 'FF_DangerousMaintenanceOperations',
    FF_TransactionDocuments = 'FF_TransactionDocuments',
}
